export default __webpack_public_path__ + "static/media/pending.5f547deb.svg";